import { render } from "./RegisteredUsers.vue?vue&type=template&id=1bb82a59&scoped=true"
import script from "./RegisteredUsers.vue?vue&type=script&lang=js"
export * from "./RegisteredUsers.vue?vue&type=script&lang=js"

import "./RegisteredUsers.vue?vue&type=style&index=0&id=1bb82a59&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1bb82a59"

export default script